export default __webpack_public_path__ + "static/media/statistics3.b0ef58b6.jpg";